import ParagraphContentBlock from "./presentational";
export default ParagraphContentBlock;
